export default __webpack_public_path__ + "static/media/faves.3c576478.svg";